import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { ClientProfileData } from '~admin/model/client-profile-data';
import { useCreateEditEventFlowStore } from '~admin/store/create-edit-event-flow-store-provider';
import { ClientDetails } from '~admin/view/components/details/client-details/client-details.component';
import { EventBaseDetails } from '~admin/view/components/details/event-details/event-base-details.component';
import { EventDatetimeDetails } from '~admin/view/components/details/event-details/event-datetime-details.component';
import { EventFeeDetails } from '~admin/view/components/details/event-details/event-fee-details.component';
import { EventLocationDetails } from '~admin/view/components/details/event-details/event-location-details';
import { EventMediaDetails } from '~admin/view/components/details/event-details/event-media-details.component';
import { EventOptionsDetails } from '~admin/view/components/details/event-details/event-options-details.component';
import { EventRestrictions } from '~admin/view/components/details/event-details/event-restrictions/event-restrictions.component';
import { EventTimelineDetails } from '~admin/view/components/details/event-details/event-timeline-details/event-timeline-details.component';
import { EventFormData } from '~admin/view/components/details/event-form-data';
import { SponsorDetails } from '~admin/view/components/details/sponsor-details/sponsor-details.component';
import { WizardPageProps } from '~admin/view/components/ui/form/wizard.component';
import { Column } from '~common/components/column.component';
import { Span } from '~common/components/span.component';
import { EventMerchandiseRestrictions } from '~admin/view/components/details/event-details/event-restrictions/event-merchandise-restrictions.component';

export const EventDetails: React.FunctionComponent<WizardPageProps<EventFormData>> = ({
  formRenderProps,
}) => {
  const { t } = useTranslation();
  const { isCreate, isEdit } = useCreateEditEventFlowStore();

  const onClientCreated = (client: ClientProfileData): void => {
    formRenderProps.form.change('clientId', client.id);
  };

  return (
    <Container>
      <FieldGroupTitle>{t('createEvent.eventDetails.client.title')}</FieldGroupTitle>
      <ClientDetails onClientCreated={onClientCreated} disabled={isEdit} />
      <EventBaseDetails />
      <FieldGroupTitle>{t('createEvent.eventDetails.location.title')}</FieldGroupTitle>
      <EventLocationDetails form={formRenderProps.form} />
      <FieldGroupTitle>{t('createEvent.eventDetails.media.title')}</FieldGroupTitle>
      <EventMediaDetails form={formRenderProps.form} />
      <FieldGroupTitle>{t('createEvent.eventDetails.dateTime.title')}</FieldGroupTitle>
      <EventDatetimeDetails />
      {isCreate && (
        <>
          <FieldGroupTitle>{t('createEvent.eventDetails.taxes.title')}</FieldGroupTitle>
          <EventFeeDetails />
        </>
      )}
      <FieldGroupTitle>{t('createEvent.eventDetails.options.title')}</FieldGroupTitle>
      <EventOptionsDetails />
      <FieldGroupTitle>{t('createEvent.eventDetails.timeline.title')}</FieldGroupTitle>
      <EventTimelineDetails />
      <FieldGroupTitle>{t('createEvent.eventDetails.restrictions.title')}</FieldGroupTitle>
      <EventRestrictions />
      <FieldGroupTitle>{t('createEvent.eventDetails.restrictions.merch.title')}</FieldGroupTitle>
      <EventMerchandiseRestrictions />
      <FieldGroupTitle>{t('details.sponsor.title')}</FieldGroupTitle>
      <SponsorDetails />
    </Container>
  );
};

const Container = styled(Column)`
  width: 100%;
`;

const FieldGroupTitle = styled(Span)`
  font-weight: bold;
  font-size: 22px;
  line-height: 22px;
  margin: 18px 0 12px;
`;



// WEBPACK FOOTER //
// ./view/components/details/event-details/event-details.component.tsx